module.exports = __webpack_public_path__ + "static/media/DINOT-Regular.c6bce69f.woff2";